import { LastPage } from "@mui/icons-material";
import { useInfiniteQuery } from "@tanstack/react-query";
import config from "configs/config";
import apiClient from "lib/api-client";

export const removeCollections = async (collectionIds) => {
  let Payload = {
    collectionId: collectionIds,
  };
  let response = await apiClient.put(`${config.baseUrl}/api/v1/collection/deleteCollections`, Payload);
  return response.data;
};

export const updateCollectionNames = async (UpdateData) => {
  let Payload = {
    collectionUpdatedData: UpdateData,
  };
  let response = await apiClient.put(`${config.baseUrl}/api/v1/collection/updateCollections`, Payload);
  return response.data;
};

export const updateCollectionDiscription = async (Payload) => {
  let response = await apiClient.put(`${config.baseUrl}/api/v1/collection/updateCollectionDiscription`, Payload);
  return response.data;
};
